import { ButtonProps } from './types';
import styles from './TertiaryButton.module.css';

export const TertiaryButton = ({
  className,
  disabled = false,
  onClick,
  text,
  type,
}: ButtonProps) => {
  return (
    <button
      className={`${className ? className + ' ' : ''}${styles.tertiaryButton}`}
      type={type}
      disabled={disabled}
      onClick={onClick}
    >
      <span className={styles.tertiaryButtonText}>{text}</span>
    </button>
  );
};
